import {atom} from 'jotai'
import {BLOG_LIST_SORTS, BLOG_LIST_SORTS_OPTIONS, BlogListSortsOptionsType} from "../../constants/constants";
import {UsersDTO} from "../../types/users/UsersDTO";

// 로그인한 사용자 정보를 가지고 있음
export const LoginUser = atom<UsersDTO>({});

export const uploadedInfo = atom<any[]>([]);

export const isBookmark = atom<boolean>(false);

export const selBlogSortOpt = atom<BLOG_LIST_SORTS>(BLOG_LIST_SORTS.LATEST);



// 댓글 여닫이
export const expandedCommentsAtom = atom<Set<string>>(new Set<string>())


// 검색
export const searchInfoQueryAtom = atom<string | undefined>("");